__turbopack_context__.v({
  "about": "item-primary-module-scss-module__hCg3pG__about",
  "chevronIcon": "item-primary-module-scss-module__hCg3pG__chevronIcon",
  "root": "item-primary-module-scss-module__hCg3pG__root",
});
